import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import TrainingClassForm from "./TrainingClassForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getTrainingClassList, 
	doTrainingClassDelete,
	doTrainingClassReset,
} from "../../../../redux/trainingclass/trainingClassState";
import SearchFilter from "components/search/SearchFilter";
import { DATE_FORMAT, TIME_FORMAT_24HM, MODULE_TRAINING_CLASS } from "variables/constants";
import dayjs from "dayjs";



const TrainingClassTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset,
}) => {


  	const columns = [
		{
	        title: `Class Title`,
	        dataIndex: 'tcl_title',
	        key: 'tcl_title',
	        width: '40%',
	        render:(tcl_title) => <span>{tcl_title}</span> 
	    },
		{
			title: `Schedule`,
			key: 'tcl_schedule',  
			width: '40%',
			render: (_, record) => (
				<span>
					{`${dayjs(record.tcl_schedule_date_from).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)} to ${dayjs(record.tcl_schedule_date_to).format(`${DATE_FORMAT} ${TIME_FORMAT_24HM}`)}`}
				</span>
			)
		},
		{
	        title: `Client Name`,
	        dataIndex: 'client_name',
	        key: 'client_name',
	        width: '20%',
	        render:(client_name) => <span>{client_name}</span> 
	    },
	    {
	        title: <PopupButton id="add_trainingClass" title="Add Training Class" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_TRAINING_CLASS}>
						<TrainingClassForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'tcl_id',
	        key: 'tcl_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute={`/console/training-classes`} 
									recordId={record?.tcl_id} 
									deleteHandler={doDelete} 
									editMode="modal"
									title="Edit Training Module"
									closeHandler={doRecordReset}
									editHandler={(recordId, doRecordReset ) => (
										<TrainingClassForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page });
	}, [doSearch, pagination.per_page ]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
			<SearchFilter placeholder="Search by Title" searchHandler={doSearch} filters={filters} pagination={pagination}/>
				<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.tcl_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
	user: state.auth.user,

});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassTable);
